import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as billingItemActions from '../../actions/billingItemActions';
import { Container, Row, Col, Button, Table } from 'reactstrap';
import BillingItem from './BillingItem';
import AddBillingItemModal from './AddBillingItemModal';
import { toast } from 'react-toastify';

class BillingItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  componentWillMount() {
    if (this.props.entryId)
      this.props.actions.loadBillingItemsForEntry(this.props.entryId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.billingItems !== nextProps.billingItems) {
      this.setState();
    }
  }

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };

  createBillingItem = (item) => {
    this.props.actions
      .saveBillingItem(item)
      .then(() => {
        toast.success('Item saved.');
        this.setState({ saving: false });
      })
      .catch((error) => {
        toast.error('Item failed to save.');
        this.setState({ saving: false });
      });
  };

  deleteBillingItem = (id) => {
    this.props.actions
      .deleteBillingItem(id)
      .then(() => {
        toast.success('Item successfully deleted.');
        this.setState({ saving: false });
      })
      .catch((error) => {
        toast.error('Item failed to delete.');
        this.setState({ saving: false });
      });
  };

  render() {
    const { billingItems } = this.props;
    const { showModal } = this.state;
    return (
      <Container fluid={true}>
        <Row>
          <Col md={3} />
          <Col md={6}>
            <h4 className={'text-center'}>Billing Items</h4>
          </Col>
        </Row>
        <Row>
          <Col md={3} />
          <Col md={6}>
            <Button
              className="mb-2"
              onClick={() => {
                this.toggleModal();
              }}
            >
              Add Item
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={3} />
          <Col md={6}>
            {billingItems.length > 0 ? (
              <Table>
                <thead>
                  <tr>
                    <th>Item Name</th>
                    <th>Item Desc</th>
                    <th>Qty</th>
                    <th>Price/Qty</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {billingItems.map((item) => (
                    <BillingItem
                      key={item.id}
                      billingItem={{ ...item }}
                      deleteBillingItem={this.deleteBillingItem}
                    />
                  ))}
                </tbody>
              </Table>
            ) : (
              <h5 className="mt-4">No items found</h5>
            )}
          </Col>
        </Row>
        <AddBillingItemModal
          show={showModal}
          entryId={this.props.entryId}
          toggle={this.toggleModal}
          createBillingItem={this.createBillingItem}
        />
      </Container>
    );
  }
}

BillingItemList.propTypes = {
  entryId: PropTypes.any,
  billingItems: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    billingItems: state.billingItems,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...billingItemActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingItemList);



// WEBPACK FOOTER //
// ./src/components/repair-log/BillingItemList.js